import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Removed StrictMode to prevent double-invocation of network requests in preview
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)